import type { LandingPageContent } from './types'

export const PHOTOVOLTAIK_PLANEN: LandingPageContent = {
  slug: 'photovoltaik-planen',
  lang: 'de',
  topicId: 'photovoltaik-planen',
  title: 'Photovoltaik planen – Schritt für Schritt',
  metaDescription:
    'Von der Dachanalyse bis zur Inbetriebnahme: So planen Sie Ihre Photovoltaikanlage richtig - ' +
    'alle Schritte im Überblick, inklusive kostenloser Anlagenberechnung.',
  keywords: [
    'Photovoltaik planen',
    'Solaranlage planen',
    'PV-Anlage Planung Ablauf',
    'Photovoltaik Schritt für Schritt',
    'Photovoltaik Reihenhaus',
  ],
  eyebrow: 'Planungs-Guide',
  h1: 'Photovoltaik planen: Der Weg zur eigenen Solaranlage',
  intro:
    'Von der ersten Dachanalyse bis zur fertig montierten Anlage sind es mehrere klare Schritte. ' +
    'Dieser Guide zeigt den gesamten Ablauf im Überblick - und verlinkt an jeder Stelle zu den ' +
    'passenden Werkzeugen und Seiten bei Roofora.',
  sections: [
    { type: 'heading', text: 'Schritt 1: Dach & Verbrauch analysieren' },
    {
      type: 'paragraph',
      text:
        'Dachausrichtung, -neigung, verfügbare Fläche und Ihr Jahresverbrauch (inklusive Wärmepumpe ' +
        'oder E-Auto, falls vorhanden) sind die Grundlage jeder Planung. Ein paar Handyfotos vom Dach ' +
        'und Zählerschrank reichen meist aus.',
    },
    { type: 'heading', text: 'Schritt 2: Passende Anlagengröße ermitteln' },
    {
      type: 'paragraph',
      text:
        'Aus diesen Angaben lässt sich eine passende Anlagenkonfiguration berechnen - Größe, Leistung ' +
        'und ob sich ein Batteriespeicher lohnt. Der kostenlose PV-Rechner liefert dazu in wenigen ' +
        'Minuten eine erste Einschätzung, ganz ohne Anmeldung.',
    },
    { type: 'heading', text: 'Schritt 3: Angebote von Handwerkern einholen und vergleichen' },
    {
      type: 'paragraph',
      text:
        'Statt einzelne Betriebe abzutelefonieren, stellen Sie eine anonymisierte Anfrage. Mehrere ' +
        'Handwerksbetriebe geben darauf unverbindliche Angebote ab, die Sie sortiert nach Preis ' +
        'vergleichen.',
    },
    { type: 'heading', text: 'Schritt 4: Handwerker auswählen und Kontakt freigeben' },
    {
      type: 'paragraph',
      text:
        'Sie prüfen Profil und Angebot jedes interessierten Betriebs und entscheiden individuell, wem ' +
        'Sie Ihre Kontaktdaten freigeben - keine pauschale Freigabe an alle.',
    },
    { type: 'heading', text: 'Schritt 5: Installation & Inbetriebnahme' },
    {
      type: 'paragraph',
      text:
        'Termin, Montage und Anmeldung der Anlage laufen direkt zwischen Ihnen und dem gewählten ' +
        'Handwerksbetrieb - ohne weitere Vermittlung. Nach der Montage können Sie den Betrieb auf ' +
        'Roofora bewerten.',
    },
  ],
  faq: [
    {
      q: 'Wie lange dauert die Planung bis zum ersten Angebot?',
      a: 'Die Anfrage selbst ist in wenigen Minuten erstellt. Handwerksbetriebe haben danach 2-4 Wochen Zeit, ein Angebot abzugeben.',
    },
    {
      q: 'Brauche ich Vorkenntnisse, um eine Anlage zu planen?',
      a: 'Nein - die passende Anlagenkonfiguration wird automatisch aus Ihren Angaben zu Dach und Verbrauch berechnet.',
    },
    {
      q: 'Funktioniert die Planung auch bei einem Reihenhaus mit begrenzter Dachfläche?',
      a: 'Ja - Sie geben "Reihenhaus" als Gebäudetyp an, Handwerksbetriebe kalkulieren ihr Angebot direkt für die tatsächlich verfügbare, oft schmalere Dachfläche.',
    },
  ],
  primaryCta: { label: 'Planung jetzt starten', action: 'link', href: '/pv-rechner' },
  secondaryCta: { label: 'Direkt Anfrage erstellen', action: 'customer' },
  relatedLinks: [
    { label: 'Kostenloser PV-Rechner', href: '/pv-rechner' },
    { label: 'PV-Kostenrechner: Durchschnittspreis in Sekunden', href: '/pv-kostenrechner' },
    { label: 'Solaranlage Kosten im Überblick', href: '/solaranlage-kosten' },
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'Photovoltaik-Anfrage erstellen', href: '/photovoltaik-anfrage-erstellen' },
    { label: 'PV-Installateur finden', href: '/pv-installateur-finden' },
    { label: 'Nur Dachmontage benötigt?', href: '/pv-module-montage' },
    { label: 'Nur Elektroinstallation benötigt?', href: '/photovoltaik-elektroinstallation' },
    { label: 'Wie berechnet Roofora den Ertrag je Dachausrichtung?', href: '/methodik-preisberechnung' },
  ],
}
